import _get from 'lodash/get';
import { FULL_HD } from '@bedrock-rdk/constants';
import { FONTS } from './dictionary';
import { FONT_TYPE } from './constants';

export { FONT, FONT_TYPE } from './constants';
export { descriptors } from './dictionary';

export const getFont = (name, resolution = FULL_HD, fontType = FONT_TYPE.MAIN) =>
  _get(FONTS, [name, resolution, fontType], {});
